module.exports = __webpack_public_path__ + "img/product2.f365a278.jpg";